import { TRANSLATION_KEYS as KEY_INITIATIVE_EDITOR_TRANSLATION_KEYS } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/translations'

import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'

import {
  DashboardChartMeasure,
  DashboardGroupBy,
  IKeyInitiativesControlsForm,
  IKeyInitiativesFiltersForm,
  IScoreCard,
} from '../model/types'

export const KEY_INITIATIVE_CONTROLS_FORM = 'KEY_INITIATIVE_CONTROLS_FORM'
export const KEY_INITIATIVE_FILTERS_FORM = 'KEY_INITIATIVE_FILTERS_FORM'

/** Use KeyInitiativesListView instead of the original KeyInitiativesTable. */
export const USE_KEY_INITIATIVES_LIST_VIEW = true

/**
 * Keeps the stored-procedure copy flow available for a safe rollback while the selective copy
 * workflow is rolled out. The selective workflow is the active implementation.
 */
export const USE_SELECTIVE_COPY_FROM_PREVIOUS_YEAR = true

/** Show hover details for validation status icons in the previous-year copy dialog. */
export const SHOW_COPY_VALIDATION_TOOLTIPS = false

/**
 * Max number of characters of the initiative description shown in the table cell
 * before it is truncated with an ellipsis (full text is available in the tooltip).
 */
export const DESCRIPTION_PREVIEW_MAX_LENGTH = 50

/** Line limits on the Capabilities Pillar tab; full text stays available on overflow. */
export const CAPABILITIES_PILLAR_NAME_MAX_LINES = 1
export const CAPABILITIES_PILLAR_DESCRIPTION_MAX_LINES = 4
export const CAPABILITIES_PILLAR_GOAL_DESCRIPTION_MAX_LINES = 5
export const CAPABILITIES_PILLAR_PROOF_OF_EXECUTION_MAX_LINES = 5

export const filtersInitialData: IKeyInitiativesFiltersForm = {
  strategicInitiatives: [],
  businessPriorities: [],
  statuses: [],
  countryCodes: [],
  keyInitiativesIds: [],
  quickFilter: null,
}

export const controlsInitialData: IKeyInitiativesControlsForm = {
  groupBy: DashboardGroupBy.StrategicInitiative,
  chartMeasure: DashboardChartMeasure.Goal,
}

export const dashboardGroupByOptions = [
  {
    key: DashboardGroupBy.StrategicInitiative,
    label: 'BU Strategic Initiative',
  },
  {
    key: DashboardGroupBy.BusinessPriority,
    label: 'GTM Business Priority',
  },
  {
    key: DashboardGroupBy.BusinessUnit,
    label: 'Business Unit',
  },
  {
    key: DashboardGroupBy.Period,
    label: 'Period',
  },
  {
    key: DashboardGroupBy.Status,
    label: 'Status',
  },
]

export const dashboardChartMeasureOptions = [
  {
    key: DashboardChartMeasure.Goal,
    label: KEY_INITIATIVE_EDITOR_TRANSLATION_KEYS.keyInitiativeEditor.goalFieldGroup.runRateMode,
  },
  {
    key: DashboardChartMeasure.Incremental,
    label: 'Incremental',
  },
  {
    key: DashboardChartMeasure.Count,
    label: 'Count of initiatives',
  },
]

export const scoreCards: IScoreCard[] = [
  {
    titleKey: TRANSLATION_KEYS.scoreCards.financialPlanCoverage.title,
    descriptionKey: TRANSLATION_KEYS.scoreCards.financialPlanCoverage.description,
  },
  {
    titleKey: TRANSLATION_KEYS.scoreCards.descriptionQuality.title,
    descriptionKey: TRANSLATION_KEYS.scoreCards.descriptionQuality.description,
  },
  {
    titleKey: TRANSLATION_KEYS.quality.strategicAlignment.title,
    descriptionKey: TRANSLATION_KEYS.quality.strategicAlignment.scoreDescription,
    bandTranslationKeys: {
      low: TRANSLATION_KEYS.quality.strategicAlignment.low,
      moderate: TRANSLATION_KEYS.quality.strategicAlignment.moderate,
      high: TRANSLATION_KEYS.quality.strategicAlignment.high,
    },
  },
]
